(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const cartBody = document.querySelector('[data-cart-body]');
  const cartCount = document.querySelector('[data-cart-count]');
  const cartTotal = document.querySelector('[data-cart-total]');

  const money = (cents) => new Intl.NumberFormat('sv-SE', { style: 'currency', currency: window.Shopify?.currency?.active || 'SEK' }).format(cents / 100);

  const openDrawer = () => { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); } };
  const closeDrawer = () => { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); } };

  const renderCart = (cart) => {
    if (cartCount) cartCount.textContent = cart.item_count;
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
    if (!cartBody) return;
    cartBody.innerHTML = cart.items.length ? cart.items.map((item, i) => `
      <div class="drawer-line">
        ${item.image ? `<img src="${item.image}&width=160" alt="${item.product_title}">` : ''}
        <div>
          <div class="drawer-line__title">${item.product_title}</div>
          <div class="drawer-line__meta">${item.quantity} × ${money(item.final_price)}${item.selling_plan_allocation ? `<br>${item.selling_plan_allocation.selling_plan.name}` : ''}</div>
          <button type="button" class="drawer-line__remove" data-line-remove="${i + 1}">Ta bort</button>
        </div>
      </div>`).join('') : '<p>Varukorgen är tom.</p>';
  };

  const refreshCart = async () => renderCart(await fetch('/cart.js').then(r => r.json()));

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-cart-open]')) openDrawer();
    if (event.target.closest('[data-cart-close]')) closeDrawer();

    const removeBtn = event.target.closest('[data-line-remove]');
    if (removeBtn) {
      removeBtn.disabled = true;
      const cart = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(removeBtn.dataset.lineRemove), quantity: 0 })
      }).then(r => r.json());
      renderCart(cart);
    }

    const qtyWrap = event.target.closest('[data-qty]');
    if (qtyWrap) {
      const input = qtyWrap.querySelector('input');
      if (event.target.closest('[data-qty-minus]')) input.value = Math.max(1, Number(input.value) - 1);
      if (event.target.closest('[data-qty-plus]')) input.value = Number(input.value) + 1;
    }
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Add to cart failed');
        await refreshCart();
        openDrawer();
      } catch (error) {
        form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const price = document.querySelector('[data-product-price]');
      const unit = document.querySelector('[data-unit-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (unit) unit.textContent = option.dataset.unitPrice || '';
    });
  });

  document.querySelectorAll('[data-dog-weight]').forEach((input) => {
    input.addEventListener('input', () => {
      const result = input.closest('[data-feeding-calc]')?.querySelector('[data-feeding-result]');
      const kg = Number(input.value);
      if (!result) return;
      if (!kg || kg < 1) { result.hidden = true; return; }
      const lo = Math.round(kg * 20);
      const hi = Math.round(kg * 30);
      const krLo = Math.round(lo * 0.12);
      const krHi = Math.round(hi * 0.12);
      result.textContent = `${lo}–${hi} g per dag, cirka ${krLo}–${krHi} kr per dag.`;
      result.hidden = false;
    });
  });
})();
